import { Link } from "react-router-dom";
import "../styles/footer.css";

function Footer() {
  return (
    <footer className="footer-container">
      <div className="footer-inner">

        <div className="footer-top">
          <div className="footer-brand">
            <span className="footer-brand-name">Mytria</span>
            <span className="footer-brand-sub">formerly MyMediaTracker</span>
          </div>

          <div className="footer-links-group">
            <span className="footer-group-heading">Community</span>
            <a href="https://www.reddit.com/r/Mytria/" target="_blank" rel="noopener noreferrer">Reddit</a>
            <a href="https://discord.gg/aSRYfbPAHa" target="_blank" rel="noopener noreferrer">Discord</a>
          </div>
          <div className="footer-links-group">
            <span className="footer-group-heading">Privacy</span>
            <Link to="/privacy">Privacy Policy</Link>
            <Link to="/terms">Terms of Service</Link>
          </div>
          <div className="footer-links-group">
            <span className="footer-group-heading">Company</span>
            <Link to="/about#about">About</Link>
            <Link to="/about#contact">Contact</Link>
          </div>  
        </div>

        <div className="footer-bottom">
          <p className="footer-copy">© 2026 Isha Shenoy. All rights reserved.</p>
          <div className="footer-badges">
            <span className="badge">Free to use</span>
            <span className="badge">Early Access</span>
          </div>
        </div>

      </div>
    </footer>
  );
}

export default Footer;